export default ({ app, $config, $integrationsManager, $uiEvents }) => {
    $uiEvents.$on('routeChanged', () => {
        if (typeof window.wisepops === 'function') window.wisepops('pageview')
    })

    /* eslint-disable */
    $integrationsManager.loaders.onNuxtReadyLoader(() => {
        (function(W,i,s,e,P,o,p){W['WisePopsObject']=P;W[P]=W[P]||function(){
            (W[P].q=W[P].q||[]).push(arguments)},W[P].l=1*new Date();o=i.createElement(s),
            p=i.getElementsByTagName(s)[0];o.async=1;o.src=e;p.parentNode.insertBefore(o,p)
            })(window,document,'script',`//loader.wisepops.com/get-loader.js?v=1&site=${$config.runtime.integrations.wisepops.siteId}`,'wisepops');

        window.wisepops('listen', 'after-form-submit', function(event) {
            const email = event.target.elements['email'].value
            let isValidEmail = /^.+\@.+\..+$/.test(email)
            if (app.$uiEvents && isValidEmail) app.$uiEvents.$emit('newsletterSubscribed', {email})
        });
    }, 10000)
}
